'use client';

import Image from 'next/image';
import { useDictionaryOptional } from '@/src/dictionaries/dictionary-provider';
import classes from './HestiaLogo.module.scss';

export const HestiaLogo = () => {
  const dictionary = useDictionaryOptional();
  const name = dictionary?.compagnyName || 'Averiane';
  const src = dictionary?.logoUrl || '/logoAveriane.webp';

  return (
    <div className={classes.logo} aria-label={name}>
      <Image src={src} alt={name} width={48} height={48} priority className={classes.logoImg} />
    </div>
  );
};
